import styles from "./price.module.css";
import RangeSlider from "../../../shared/slider/RangeSlider";
import { HeadingTitle } from "../../../shared/index";

const PriceFilter = ({ min, max, heading, filtersProps, filtersActions }) => {
  const { priceRange } = filtersProps;
  const { setPriceRange } = filtersActions;
  return (
    <>
      <HeadingTitle text={heading || ""} style={styles.sectionTitle} />
      <div className={styles.priceRangeWrapper}>
        <RangeSlider
          price={priceRange}
          setPrice={setPriceRange}
          min={min}
          max={max}
        />
        <div className={styles.priceDisplay}>
          Price: ₹{priceRange[0]} - ₹{priceRange[1]}
        </div>
      </div>
    </>
  );
};

export default PriceFilter;
